import React from 'react';
import { Button } from "@mui/material";
import { Icon } from "@fluentui/react";

type RetryProps = {
  errorMessage: string;
  refreshHandler: () => void;
};

const RetryErrorPage: React.FC<RetryProps> = ({ errorMessage, refreshHandler }) => {
  return (
    <div className="denied">
      <div className="denied__content">
        <img alt="logo" src="/icon.png" style={{ float: "left", width: "50px", height: "50px" }} />
        <div className="denied__message">
          {errorMessage}
          <br />
          <br />
          <Button className="refresh" variant="outlined" onClick={refreshHandler}>
            Try again
            <div className="refresh-icon">
              <Icon iconName="refresh" />
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RetryErrorPage;